import { useMemo } from "react";
import { PageType, SingularPage } from "../../../../types";
import img_notes from "../../../../assets/images/evidens_saerlige_bemaerkninger.png";
import img_evidens from "../../../../assets/images/evidens_grafik.png";
import img_method from "../../../../assets/images/metode_grafik.png";
import img_science from "../../../../assets/images/publicering_grafik.png";

const imageMap = new Map<string, string>([
  [PageType.evidence, img_evidens],
  [PageType.method, img_method],
  [PageType.notes, img_notes],
  [PageType.science, img_science],
]);

interface Props {
  currentPage: SingularPage;
}

export function PageImage({ currentPage }: Props) {
  const img = useMemo(() => {
    return imageMap.get(currentPage.type);
  }, [currentPage.type]);

  return <img src={img} alt="grafik" className="w-full  object-cover" />;
}
